const states = [
  {
    name: 'Andaman and Nicobar',
    value: 'andaman and nicobar',
  },
  {
    name: 'Andhra Pradesh',
    value: 'andhra pradesh',
  },
  {
    name: 'Arunachal Pradesh',
    value: 'arunachal pradesh',
  },
  {
    name: 'Assam',
    value: 'assam',
  },
  {
    name: 'Bihar',
    value: 'bihar',
  },
  {
    name: 'Chandigarh',
    value: 'chandigarh',
  },
  {
    name: 'Chattisgarh',
    value: 'chattisgarh',
  },
  {
    name: 'Dadra and Nagar Haveli',
    value: 'dadra and nagar haveli',
  },
  {
    name: 'Daman and Diu',
    value: 'daman and diu',
  },
  {
    name: 'Delhi',
    value: 'Delhi',
  },
  {
    name: 'Goa',
    value: 'goa',
  },
  {
    name: 'Gujrat',
    value: 'gujrat',
  },
  {
    name: 'Haryana',
    value: 'haryana',
  },
  {
    name: 'Himachal Pradesh',
    value: 'himachal pradesh',
  },
  {
    name: 'Jammu & Kashmir',
    value: 'jammu and kashmir',
  },
  {
    name: 'Jharkhand',
    value: 'jharkhand',
  },
  {
    name: 'Karnataka',
    value: 'karnataka',
  },
  {
    name: 'Kerala',
    value: 'kerala',
  },
  {
    name: 'Madhya Pradesh',
    value: 'madhya pradesh',
  },
  {
    name: 'Maharashtra',
    value: 'maharashtra',
  },
  {
    name: 'Manipur',
    value: 'manipur',
  },
  {
    name: 'Meghalaya',
    value: 'meghalaya',
  },
  {
    name: 'Mizoram',
    value: 'mizoram',
  },
  {
    name: 'Nagaland',
    value: 'nagaland',
  },
  {
    name: 'Lakshadweep',
    value: 'lakshadweep',
  },
  {
    name: 'Odisha',
    value: 'odisha',
  },
  {
    name: 'Puducherry',
    value: 'puducherry',
  },
  {
    name: 'Punjab',
    value: 'punjab',
  },
  {
    name: 'Rajasthan',
    value: 'rajasthan',
  },
  {
    name: 'Sikkim',
    value: 'sikkim',
  },
  {
    name: 'Tamil Nadu',
    value: 'tamil nadu',
  },
  {
    name: 'Telangana',
    value: 'telangana',
  },
  {
    name: 'Tripura',
    value: 'tripura',
  },
  {
    name: 'Uttar Pradesh',
    value: 'uttar pradesh',
  },
  {
    name: 'Uttarakhand',
    value: 'uttarakhand',
  },
  {
    name: 'West Bengal',
    value: 'west bengal',
  },
];

export default states;



// WEBPACK FOOTER //
// ./src/utils/states.js